export function formatReadingTime(value: any) {
    if (value === undefined || value === null || isNaN(value)) {
        return;
    }

	value = Math.round(value);

	return (Math.floor(value / 60)) + ':' + ('' + Math.round((value - Math.floor(value / 60) * 60))).padStart(2, '0');
}

export default formatReadingTime;
